import { render } from "./Fornecedor.vue?vue&type=template&id=57ec4196&scoped=true"
import script from "./Fornecedor.vue?vue&type=script&lang=js"
export * from "./Fornecedor.vue?vue&type=script&lang=js"

import "./Fornecedor.vue?vue&type=style&index=0&id=57ec4196&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ec4196"]])

export default __exports__